import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { BotonFormComponent } from '../provisionador/boton-form/boton-form.component';
import { CategoriaArmadoComponent } from '../provisionador/categoria-armado/categoria-armado.component';
import { ProvisionadorPreviewComponent } from '../provisionador/preview/provisionador-preview.component';
import { CategoriaEditorComponent } from './categoria-editor.component';

/**
 * Piezas reutilizables del editor de categoría (preview + botón + armado + editor), compartidas
 * entre el módulo de clientes (provisionador / editor de cliente) y el de categorías. Se declaran acá
 * y se exportan para que ambos módulos las usen sin duplicar declaraciones ni chocar routing.
 */
@NgModule({
  declarations: [
    BotonFormComponent,
    CategoriaArmadoComponent,
    ProvisionadorPreviewComponent,
    CategoriaEditorComponent,
  ],
  imports: [CommonModule, AuxiliaresModule],
  exports: [
    BotonFormComponent,
    CategoriaArmadoComponent,
    ProvisionadorPreviewComponent,
    CategoriaEditorComponent,
  ],
})
export class CategoriaEditorSharedModule {}
